<div  fxLayout="column" class="page-container">
  <div fxLayout="column" class="instruction-container" fxLayoutAlign="center center">
    <div  fxLayoutAlign="center center" fxLayout="column">
      <h1>How it works:</h1>
      <ul class="instruction-list">
        <li><span class="number">1.</span> You will be given 10 questions. Each question has 4 answer options, but only 1 is correct.</li>
        <li><span class="number">2.</span> You have 30 seconds for each question.</li>
        <li><span class="number">3.</span> The faster you answer, the more points you collect.</li>
        <li><span class="number">4.</span> The higher your score, the bigger your prize!</li>
      </ul>
    </div>
    <div class="button-container">
      <eon-ui-button fullWidth text="Start the Game" (click)="navigateToQuestions()" scheme=white></eon-ui-button>
    </div>
</div>

